import { UserRole, IUsersRoleResponse } from '@/types/common/users'
import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'

export const PATH = {
  GET_USERS_ME: 'api/common/users/me',
} as const

export class UsersApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * ユーザ情報取得API
   * @returns ログイン種別  guest | member | photographer
   */
  public async getUsersRole(): Promise<UserRole> {
    const { data } = await this.baseApi.get<IUsersRoleResponse>(PATH.GET_USERS_ME)
    return data.role
  }
}
